'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var getRenderOption = function (option) { return (React__default.createElement("div", { className: option.disabled ? 'disabled' : '', "data-testid": 'option' }, option.display)); };

exports.getRenderOption = getRenderOption;
